export default __webpack_public_path__ + "static/media/Emp_data_pic.46505a38.png";